import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {setCookie} from "../../utils/cookie";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const updateSupplier = createAsyncThunk(
    'supplier/update',
    async (params: any, { rejectWithValue }) => {
    
        const updateURL = `${URL_API}/admin-portal/suppliers/${params.supplierID}/details`;

        try {
            const { data } = await axios.put<ResetResult>(updateURL, params.data, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {

            // @ts-ignore
            if(error.response.status === 401){
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);